// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Qv3S","log":"ModalInventoryLogs_log__TaQUf","date":"ModalInventoryLogs_date__35rGQ","userName":"ModalInventoryLogs_userName__YApTh"};